module.exports = __webpack_public_path__ + "de3b38ffcf41a0d1633d84593cc1cd7d.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/prize_6.png
// module id = 116
// module chunks = 0